import { render, staticRenderFns } from "./step.vue?vue&type=template&id=78451156&scoped=true&"
import script from "./step.vue?vue&type=script&lang=js&"
export * from "./step.vue?vue&type=script&lang=js&"
import style0 from "./step.vue?vue&type=style&index=0&id=78451156&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78451156",
  null
  
)

export default component.exports